import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/metrics',
)({
  // Observability surface, as the space metrics tab.
  staticData: {
    domain: 'monitoring',
  },
  component: lazyRouteComponent(
    () => import('@/components/Serverless/SpaceCollections/SpaceCollectionMetrics'),
    'SpaceCollectionMetrics',
  ),
});
